var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgAi = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "M7.91 2.16c0 4.374 3.092 7.92 6.908 7.92-3.816 0-6.909 3.546-6.909 7.92 0-4.374-3.093-7.92-6.909-7.92 3.816 0 6.91-3.546 6.91-7.92M13.727 0c0 2.187 1.466 3.96 3.273 3.96-1.807 0-3.273 1.773-3.273 3.96 0-2.187-1.465-3.96-3.273-3.96 1.808 0 3.273-1.773 3.273-3.96" }) }))); };
export default SvgAi;
